import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { Spinner } from '../ui/StyledComponents';

// Lazy load pages for better performance
const Home = lazy(() => import('../features/products/pages/Home'));
const Store = lazy(() => import('../features/products/pages/Store'));
const ProductDetails = lazy(() => import('../features/products/pages/ProductDetails'));
const Cart = lazy(() => import('../features/cart/pages/Cart'));
const Login = lazy(() => import('../features/auth/pages/Login'));
const Register = lazy(() => import('../features/auth/pages/Register'));
const AdminDashboard = lazy(() => import('../features/admin/pages/AdminDashboard'));
const AdminProducts = lazy(() => import('../features/admin/pages/AdminProducts'));
const Club = lazy(() => import('../features/products/pages/Club'));

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spinner size="60px" $center />
  </div>
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Catalogue public ; panier, club et administration réservés aux comptes connectés */}
        <Route path="/" element={<Home />} />
        <Route path="/store" element={<Store />} />
        <Route path="/product/:productId" element={<ProductDetails />} />
        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/club"
          element={
            <ProtectedRoute>
              <Club />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/products"
          element={
            <ProtectedRoute>
              <AdminProducts />
            </ProtectedRoute>
          }
        />

        {/* Redirect any unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
